export async function getFunctionaryQuestionaries(resource) {
  const user = JSON.parse(window.localStorage.getItem("user") || "{}");
  const profile = window.localStorage.getItem("perfil");

  if (!user.location_id || !user.stament_id || !profile) {
    throw new Error("Faltan datos de la cuenta para cargar las encuestas.");
  }

  const response = await resource.get(
    `api/${profile}/questionary_location/find_by_stablishment_and_stament_id/${user.location_id}/Abierta/${user.stament_id}`
  );
  return Array.isArray(response.body.questionary) ? response.body.questionary : [];
}

export function hasAnsweredQuestionary(item) {
  const entries = item && item.questionary && item.questionary.users_questionaries;
  return Array.isArray(entries) && entries.length > 0;
}
